import { render, staticRenderFns } from "./MyTournamentsRanking.vue?vue&type=template&id=7fb64d7e&scoped=true"
import script from "./MyTournamentsRanking.vue?vue&type=script&lang=js"
export * from "./MyTournamentsRanking.vue?vue&type=script&lang=js"
import style0 from "./MyTournamentsRanking.vue?vue&type=style&index=0&id=7fb64d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb64d7e",
  null
  
)

export default component.exports